<template>
  <div
    class="ba-absolute ba-z-1 ba-flex ba-items-center ba-select-none ba-cursor-default ba-transform ba--translate-x-1/2"
    :class="[
      markPosition,
      markDirection,
      {'ba-mt-1': queueType === 'параллельное' },
      {'ba--mt-2': queueType === 'параллельное' && expired }
    ]"
    @click.stop
  >
    <div
      class="ba-flex ba-flex-shrink-0 ba-w-8 ba-h-8 ba-rounded-full"
      :class="[
        getTaskStatusColor(status),
        {'ba-mb-1': queueType === 'параллельное'}
      ]"
    >
      <component :is="`vis-icon-${getTaskStatusIcon(status)}`" class="ba-h-3 ba-m-auto ba-text-white" />
    </div>
    <div
      v-if="expired"
      class="ba-flex ba-w-6 ba-h-6  ba-bg-error-strong ba-rounded-full"
      :class="{'ba-ml-2': queueType !== 'параллельное'}"
    >
      <vis-icon-exclamation class="ba-h-2 ba-m-auto ba-text-white" />
    </div>
  </div>
</template>

<script>
import visApprovalQueueTaskConnectionLine from "./vis-approval-queue-task-connection-line";

export default {
  name: "vis-approval-queue-task-status-mark",
  components: {
    visApprovalQueueTaskConnectionLine
  },
  props: {
    queueType: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: null
    },
    expired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    markPosition() {
      return this.queueType === 'последовательное' ?
        'ba-left-1/2 ba-top-0 ba--translate-y-1/2':
        'ba-left-0'
    },
    markDirection() {
      return this.queueType === 'последовательное' ?
        null:
        'ba-flex-col ba-justify-center'
    }
  },
  methods: {
    getTaskStatusIcon(val) {
      switch(val) {
        case "задача в ожидании":
          return "pause";
        case "задача в работе":
          return "hourhands";
        case "завершено с положительным результатом (т.е. согласовано)":
          return "done";
        case "завершено с отрицательным результатом (т.е. отклонено)":
          return "close";
        default:
          return "pause";
      }
    },
    getTaskStatusColor(val) {
      switch (val) {
        case "задача в ожидании":
          return "ba-bg-background-blue-grey";
        case "задача в работе":
          return "ba-bg-accent";
        case "завершено с положительным результатом (т.е. согласовано)":
          return "ba-bg-success-strong";
        case "завершено с отрицательным результатом (т.е. отклонено)":
          return "ba-bg-error-weak";
        default:
          return "ba-bg-background-blue-grey";
      }
    }
  }
}
</script>
